import { filter, map, isString } from 'lodash';
import Label from '../model/label/Label';
import { LabelType } from '../model/label/Label.enum';

export const predefinedDefaultProperties = {
  color: { name: 'blue_grey_800' },
  isActive: true,
  isLocked: true
};

export const predefinedValues = () => [
  // region CONTACT TYPE
  {
    id: '5fc8a573-5d6f-427e-acd8-a435dff25fd6',
    name: 'Accountant',
    type: { name: 'contact' }
  },
  {
    id: '2ad70288-34e7-4fb1-9662-fa101389870f',
    name: 'Assessor',
    type: { name: 'contact' }
  },
  {
    id: 'e7e0844e-af08-4734-9182-cd10d118eaaa',
    name: 'Auditor',
    type: { name: 'contact' }
  },
  {
    id: 'f017b136-6988-46a8-8a2d-e29e8033673f',
    name: 'Beneficiary',
    type: { name: 'contact' }
  },
  {
    id: '90f14042-9110-445e-8e6e-4417bedf06f4',
    name: 'Builder',
    type: { name: 'contact' }
  },
  {
    id: '5772ddbb-f89a-48e4-843b-0cf7d041f785',
    name: 'Business Partner',
    type: { name: 'contact' }
  },
  {
    id: '1c671835-7241-46d0-beaa-de1d7f613d96',
    name: 'Buyers agent',
    type: { name: 'contact' }
  },
  {
    id: '6cd3e44c-6b2c-426f-a4f7-079405a74107',
    name: 'CEO',
    type: { name: 'contact' }
  },
  {
    id: '018a40bf-027a-4a08-9910-a0cbb058ddab',
    name: 'Client',
    type: { name: 'contact' }
  },
  {
    id: 'c2babc6c-a4c5-4deb-99fc-b0780e7b35c1',
    name: 'Commercial lender',
    type: { name: 'contact' }
  },
  {
    id: 'a181539e-e964-4d67-b3d9-da4b9fdee312',
    name: 'Contractor',
    type: { name: 'contact' }
  },
  {
    id: '2ed149c6-2b4e-4f28-a6bd-fe7708331b5b',
    name: 'COO',
    type: { name: 'contact' }
  },
  {
    id: '07c75870-0e66-4b61-b56f-770ccaa551bd',
    name: 'Developer',
    type: { name: 'contact' }
  },
  {
    id: 'a91d6341-5372-475b-841d-b89c5998ac66',
    name: 'Director',
    type: { name: 'contact' }
  },
  {
    id: '1a8a91f8-5666-4ce6-9a78-5cf9a49b5367',
    name: 'Employee',
    type: { name: 'contact' }
  },
  {
    id: 'fa625960-e2ab-4699-bab3-57a721f8bce0',
    name: 'Finance broker',
    type: { name: 'contact' }
  },
  {
    id: 'a8b080e6-6041-43a2-bce3-b50503019504',
    name: 'Financial advisor',
    type: { name: 'contact' }
  },
  {
    id: '91ca1a29-6fdb-4b65-bcec-fab85892ed56',
    name: 'General manager',
    type: { name: 'contact' }
  },
  {
    id: '5ba8db09-da48-4b26-8766-05a8e1d09c88',
    name: 'Head of distribution',
    type: { name: 'contact' }
  },
  {
    id: 'f298fa78-3991-4e8c-9319-c14ee9b5c9d1',
    name: 'Insurer',
    type: { name: 'contact' }
  },
  {
    id: 'd24fefd4-ad7d-4d69-a35d-4b1f84bb1b30',
    name: 'Landlord',
    type: { name: 'contact' }
  },
  {
    id: '78edd653-2bf9-4a78-8cb9-15f0e44928d9',
    name: 'Lender',
    type: { name: 'contact' }
  },
  {
    id: '30aa7c93-a721-45cc-a4a6-01e16feffff4',
    name: 'Mortgage manager',
    type: { name: 'contact' }
  },
  {
    id: '489f97cf-2952-4bda-8c0a-8e24856315a8',
    name: 'National manager',
    type: { name: 'contact' }
  },
  {
    id: 'ef8154b0-7bda-4d1e-a87e-f286c06f7d94',
    name: 'Non-borrowing spouse',
    type: { name: 'contact' }
  },
  {
    id: '91014368-29c2-4a66-8d36-b88f50b70da3',
    name: 'Other',
    type: { name: 'contact' }
  },
  {
    id: '67da720d-b94d-4f74-ab29-e109bd780b33',
    name: 'Potential lead',
    type: { name: 'contact' }
  },
  {
    id: 'f589a325-f614-4a59-ab49-5720a4fd6756',
    name: 'Potential referrer',
    type: { name: 'contact' }
  },
  {
    id: 'dc0947fa-cc42-4504-87f7-f320618e2e3b',
    name: 'Primary',
    type: { name: 'contact' }
  },
  {
    id: '4f96e10f-49f5-4634-9af6-e28544e300a8',
    name: 'Property manager',
    type: { name: 'contact' }
  },
  {
    id: '748417ed-4f58-46d0-aaac-1a01c072f70b',
    name: 'Real estate agent',
    type: { name: 'contact' }
  },
  {
    id: '58ac3382-83c8-4b80-9c96-5eb5be9e604a',
    name: 'Real estate principal',
    type: { name: 'contact' }
  },
  {
    id: '41674e36-4b27-4e77-914e-e9e39d188263',
    name: 'Referrer',
    type: { name: 'contact' }
  },
  {
    id: '86ecc076-a2cc-46e8-a64c-edddd29ba3fa',
    name: 'Regional manager',
    type: { name: 'contact' }
  },
  {
    id: '64d5a6dc-e308-476a-8a9f-66f85ac7318f',
    name: 'Sales agent',
    type: { name: 'contact' }
  },
  {
    id: 'e2cd11d9-7c67-4e2b-b3f5-5cdcac08ace7',
    name: 'Secondary',
    type: { name: 'contact' }
  },
  {
    id: 'd583957c-3ee9-4ec2-b041-efa0f8d41875',
    name: 'Security guarantor',
    type: { name: 'contact' }
  },
  {
    id: 'e542c9e7-ba5c-4ac3-9234-52263b157271',
    name: 'Servicing guarantor',
    type: { name: 'contact' }
  },
  {
    id: '603d1ca5-82e7-48d2-98b6-885a57315f9e',
    name: 'Solicitor',
    type: { name: 'contact' }
  },
  {
    id: '434ca1cb-edf2-4448-8cb9-bff59f22f6f8',
    name: 'State manager',
    type: { name: 'contact' }
  },
  {
    id: '1f72f021-59be-40cd-8494-30f1c979273b',
    name: 'Superfund',
    type: { name: 'contact' }
  },
  {
    id: '6ec19ba4-b437-4a83-936f-c6fb4813728d',
    name: 'LoanQ',
    type: { name: 'contact' }
  },
  {
    id: 'c212964b-3fa6-4759-8e66-5e973f739f93',
    name: 'WebloanQ',
    type: { name: 'contact' }
  },
  // endregion CONTACT TYPE
  // region FILE TYPE
  {
    id: '9059b449-5822-4daf-a05b-a64f606000b7',
    name: 'Commercial',
    type: { name: 'file' }
  },
  {
    id: '64e278ae-02ee-46db-a12a-31a4e151fada',
    name: 'Personal',
    type: { name: 'file' }
  },
  {
    id: 'b19be6ae-e9d7-4434-8c61-9c5e8fe0c839',
    name: 'Business',
    type: { name: 'file' }
  },
  {
    id: '96e10ab4-fe1b-4ceb-80b1-f29dae2bfe33',
    name: 'Asset Finance',
    type: { name: 'file' }
  },
  {
    id: '98e479e3-c8c4-4a3d-acfd-66996d6f8bcc',
    name: 'Home Loan',
    type: { name: 'file' }
  },
  {
    id: '0c137175-fa5b-41d4-817d-ba6652fbc7b3',
    name: 'Application form',
    type: { name: 'file' }
  },
  {
    id: '816b6ed3-d11f-4884-9856-522108e644c9',
    name: 'Credit proposal disclosure',
    type: { name: 'file' }
  },
  {
    id: '6cf99ed0-6ebb-4624-954e-a46a9e5fe396',
    name: 'Credit guide',
    type: { name: 'file' }
  },
  {
    id: '4c9fe936-615d-469b-9f79-bdcfe97b4273',
    name: 'Credit quote',
    type: { name: 'file' }
  },
  {
    id: '5e0c54aa-16d1-48cb-84f5-6464ed1bb7fe',
    name: 'Fact find',
    type: { name: 'file' }
  },
  {
    id: 'c9646a94-7550-4d21-b4c6-8a06b9a1a3fc',
    name: 'Preliminary assessment',
    type: { name: 'file' }
  },
  {
    id: '16c0f52e-949f-4546-beeb-82449ee0ead8',
    name: 'Privacy disclosure',
    type: { name: 'file' }
  },
  {
    id: '0620f3cb-7717-4a86-885d-8b4613cf5dec',
    name: 'Sales document',
    type: { name: 'file' }
  },
  {
    id: 'b439325f-9a88-4590-ba6f-c814e150a039',
    name: 'Statement report',
    type: { name: 'file' }
  },
  {
    id: 'abf23da2-1228-41d6-969a-619a6cef79af',
    name: 'ID report',
    type: { name: 'file' }
  },
  {
    id: 'e584cff0-f70f-412e-a0d6-0ac5c8b66de6',
    name: 'Credit report',
    type: { name: 'file' }
  },
  {
    id: '97822f53-86d9-406a-a5c3-4533926673db',
    name: 'Property report',
    type: { name: 'file' }
  },
  {
    id: 'b11a57a5-548e-4b05-b928-fc085cd68e3f',
    name: 'PPSR report',
    type: { name: 'file' }
  },
  {
    id: 'aa562b53-c382-49fe-957c-a003daedc295',
    name: 'eSigned',
    type: { name: 'file' }
  },
  {
    id: '833a88d1-ca23-4ab6-8b51-fc794bcd87cb',
    name: 'LoanQ',
    type: { name: 'file' }
  },
  {
    id: '23549be6-3aec-11ec-8d3d-0242ac130003',
    name: 'WebloanQ',
    type: { name: 'file' }
  },
  // endregion FILE TYPE
  // region JOB TYPE
  {
    id: '235c35e1-c183-4c95-af89-ac3b47b5fcf2',
    name: 'Client call',
    type: { name: 'job' }
  },
  {
    id: 'd532e241-aaac-497d-ac39-f64403a4c3de',
    name: 'Compliance check',
    type: { name: 'job' }
  },
  {
    id: 'ac1a9487-0f4d-4933-95b2-38a425fe49e2',
    name: 'Upload documents',
    type: { name: 'job' }
  },
  {
    id: '541286e5-d9c0-45d0-adb3-dcf7c4beee7c',
    name: 'LoanQ',
    type: { name: 'job' }
  },
  {
    id: '01f1bccd-d89b-4bd4-9a5a-39b6615a4561',
    name: 'WebloanQ',
    type: { name: 'job' }
  },
  // endregion JOB TYPE
  // region NOTE TYPE
  {
    id: '1eca2fa3-2eea-4676-b233-cad83cc7e54e',
    name: 'Automation',
    type: { name: 'note' }
  },
  {
    id: 'd9b7c460-2cb6-42bd-95b2-12f53b689796',
    name: 'Call',
    type: { name: 'note' }
  },
  {
    id: 'ebaa84f3-a7f0-463b-9a77-ef9c69d69218',
    name: 'Comment',
    type: { name: 'note' }
  },
  {
    id: '2d5b57fd-ee6f-4ed8-af09-932fd1ac4877',
    name: 'Email',
    type: { name: 'note' }
  },
  {
    id: '4e1aebb9-8740-40b3-a0e2-19af97e036c0',
    name: 'Signature',
    type: { name: 'note' }
  },
  {
    id: '35031e39-3dc9-468b-9967-a5c629b6d6a6',
    name: 'Sms',
    type: { name: 'note' }
  },
  {
    id: 'f1e8b198-a6e4-4f8e-bb6f-eca55fc23176',
    name: 'Video',
    type: { name: 'note' }
  },
  {
    id: '617a9b41-66fe-4366-92c9-263b0c3ce2e6',
    name: 'LoanQ',
    type: { name: 'note' }
  },
  {
    id: '8d2330ff-a7e2-492d-8f67-e4a93dec7f0f',
    name: 'WebloanQ',
    type: { name: 'note' }
  },
  // endregion NOTE TYPE
  // region TICKET TYPE
  {
    id: '67eb727d-089c-4532-a1fc-739893d78100',
    name: 'Commercial',
    type: { name: 'ticket' }
  },
  {
    id: '821a7744-b405-449c-83bd-4ddd03207413',
    name: 'Personal',
    type: { name: 'ticket' }
  },
  {
    id: '1dce3d4e-477d-43f3-9858-1a3b86c3acfa',
    name: 'Business',
    type: { name: 'ticket' }
  },
  {
    id: '875ba941-a996-4612-9c7b-e6b198b94c44',
    name: 'Asset Finance',
    type: { name: 'ticket' }
  },
  {
    id: 'eef1967c-9e4c-4cec-813a-0b3880e53c2a',
    name: 'Home Loan',
    type: { name: 'ticket' }
  },
  {
    id: '0d86aabd-82b1-4f23-8aac-314a863264f5',
    name: 'Incomplete',
    type: { name: 'ticket' }
  },
  {
    id: 'b70b317b-5de4-4064-8e45-a0e5e6b3f4fb',
    name: 'On hold',
    type: { name: 'ticket' }
  },
  {
    id: '0dce154f-877f-4c4f-b937-e4934788ed4f',
    name: 'On track',
    type: { name: 'ticket' }
  },
  {
    id: '9ddaa093-bcbe-4de6-bfe4-8b3e3f5f825d',
    name: 'Referred',
    type: { name: 'ticket' }
  },
  {
    id: 'f24ab6c7-d693-4e10-92bf-6fd6ce7d2a9d',
    name: 'LoanQ',
    type: { name: 'ticket' }
  },
  {
    id: '71f6833a-6140-4343-83ed-bc1e30f85fbf',
    name: 'WebloanQ',
    type: { name: 'ticket' }
  }
  // endregion TICKET TYPE
];

export const predefined = (type: LabelType): Array<Label> =>
  map(
    type
      ? filter(predefinedValues(), isString(type) ? { type: { name: type } } : { type })
      : predefinedValues(),
    (l: any) => new Label({ ...l, ...predefinedDefaultProperties })
  );

export default {
  predefined
};
